import { render } from "./Search.vue?vue&type=template&id=cfed8aa6&scoped=true&ts=true"
import script from "./Search.vue?vue&type=script&lang=ts"
export * from "./Search.vue?vue&type=script&lang=ts"

import "./Search.vue?vue&type=style&index=0&id=cfed8aa6&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\slow\\slowshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfed8aa6"]])

export default __exports__